import { Api, ApiConfig } from 'bimplus-websdk';
import { createRxRequest } from '../rx-request/rx-request.factory';

/**
 * Extends the Api instance with rxRequest method.
 * This factory have to be used withing injection context (e.g. in a provider factory) to properly inject dependencies for rxRequest.
 */
export function bimplusApiFactory(apiConfig: ApiConfig): Api {
  const api = new Api(apiConfig);
  api.rxRequest = createRxRequest();

  return api;
}
